<div class="animated fadeIn">
  <div class="row">
    <div class="col-md-12 mb-4">
      <tabset>
        <tab heading="Items">
          <app-shop-items-tab></app-shop-items-tab>
        </tab>
        <tab heading="Packs" (selectTab)="onSelectPacksTab()">
          <app-shop-packs-tab #packsTab></app-shop-packs-tab>
        </tab>
        <tab heading="Statistics" (selectTab)="onSelectStatisticsTab()">
          <app-shop-statistics-tab #statisticsTab></app-shop-statistics-tab>
        </tab>
        <tab heading="Configurations">
          <app-configurations-block [configurations]="shopConfigurations" [collapsible]="false" />
        </tab>
      </tabset>
    </div>
  </div>
</div>
